import { Modal } from 'src/components/elements'
import { Fragment, Ref } from 'react'
import { ModalActionModel } from 'src/models/modal-action-model'
import round from 'src/helpers/round'
import addComma from 'src/helpers/addComma'

export interface IModalShowMoreItems {
  modalRef?: Ref<ModalActionModel>
  items: {
    name: string
    description: string | null
    quantity: number
    amount: number
  }[]
  transactionFee: number
  totalAmount: number
}

const ModalShowMoreItems: React.FC<IModalShowMoreItems> = ({
  modalRef,
  items,
  transactionFee,
  totalAmount,
}) => {
  return (
    <Modal
      ref={modalRef}
      isSmallModal={true}
      title="Paying For"
      maxWidth={'max-w-[650px]'}
    >
      <div className="max-w-[40rem] mx-auto flex flex-col space-y-4 sm:p-4 w-full">
        <div className="grid grid-cols-8 sm:grid-cols-10 gap-2 w-full items-center">
          <div className="col-span-4 font-semibold text-left">Item</div>
          <div className="col-span-2 font-semibold text-center">Qty</div>
          <div className="col-span-2 font-semibold text-center">Amount</div>
          <div className="col-span-2 font-semibold text-right hidden sm:block">
            Total
          </div>
          {items.map((item, index) => (
            <Fragment key={index}>
              <div className="col-span-4 text-left py-2">
                <p className="font-semibold text-sm sm:text-base">
                  {item.name}
                </p>
                <p className="opacity-50 text-sm">
                  {item.description ?? <em>(No description)</em>}
                </p>
              </div>
              <div className="col-span-2 text-center  py-2 text-sm sm:text-base">
                {item.quantity}
              </div>

              <div className="col-span-2 text-center  py-2 text-sm sm:text-base">
                ₱{` `}
                {addComma(round(item.amount, 2))}
              </div>

              <div className="col-span-2 text-right py-2 text-sm sm:text-base hidden sm:block">
                ₱{` `}
                {addComma(round(item.quantity * item.amount, 2))}
              </div>
            </Fragment>
          ))}
        </div>

        <div className=" border-b w-full"></div>
        <div className="flex items-center justify-between">
          <div>Subtotal</div>
          <div>
            <b>
              ₱{` `}
              {addComma(totalAmount - transactionFee)}
            </b>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div>Transaction Fee</div>
          <div>
            <b>
              ₱{` `}
              {addComma(transactionFee)}
            </b>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div>Total Amount</div>
          <div className="text-primary">
            <b>
              ₱{` `}
              {addComma(totalAmount)}
            </b>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalShowMoreItems
